<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("Atendimento");
export default {
  name: "App",
  components: {},
  created () {
    this.getState();
  },
  methods: {
    ...mapActions(["getState"])
  }
};
</script>

<style>
html {
  overflow-y: hidden;
}

#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-y: hidden;
  overflow-x: hidden;
}

/* @import "~@angular/material/prebuilt-themes/indigo-pink.css"; */

.bubble {
  background-color: #f2f2f2;
  border-radius: 5px;
  box-shadow: 0 0 6px #b2b2b2;
  display: inline-block;
  padding: 6px 15px;
  position: relative;
  /* width: 35%; */
  vertical-align: top;
}

.bubble::before {
  /* background-color: #F2F2F2; */
  content: "\00a0";
  display: block;
  height: 16px;
  position: absolute;
  top: 11px;
  transform: rotate(29deg) skew(-35deg);
  -moz-transform: rotate(29deg) skew(-35deg);
  -ms-transform: rotate(29deg) skew(-35deg);
  -o-transform: rotate(29deg) skew(-35deg);
  -webkit-transform: rotate(29deg) skew(-35deg);
  width: 20px;
}

.server {
  float: left;
  padding-top: 20px;
  margin: 5px 45px 5px 40px;
  font-weight: bold;
  color: #666;
}

.danger {
  float: left;
  padding-top: 20px;
  background-color: #dc3545 !important;
  margin: 5px 45px 5px 40px;
  color: #fff;
  font-weight: bold;
}

.you {
  float: left;
  background-color: #0A92C4;
  /* padding-left: 50px !important;
    padding-right: 50px !important;  */
  margin: 5px 150px 5px 45px;
  overflow-wrap: break-word !important;
}

.you p {
  overflow-wrap: break-word;
  max-width: 300px;
}

.you pre {
  overflow-wrap: break-word;
  max-width: 300px;
}

pre {
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.me p {
  overflow-wrap: break-word;
  max-width: 300px;
}

.you::before {
  box-shadow: -2px 2px 2px 0 rgba(178, 178, 178, 0.4);
  background-color: #0A92C4;
  box-shadow: 2px -2px 2px 0 #0A92C4 !important;
  left: -9px;
}

.me {
  color: #000;
  background-color: #ff9800;
  float: right;
  /* padding-left: 50px !important;
    padding-right: 50px !important;  */
  margin: 5px 20px 5px 150px;
}

.me::before {
  background-color: #ff9800;
  /* box-shadow: 2px -2px 2px 0 #ff9800; */
  right: -9px;
}

.chat-button.hidden {
  display: none;
}

.chat-button {
  position: fixed;
  bottom: 20px;
  right: 20px;

  box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.52);

  background: #0A92C4;
  border: 1px #0A92C4 solid;

  width: 60px;
  height: 60px;
  border-radius: 30px;

  cursor: pointer;
}

.chat-button svg {
  width: 45px;
  position: relative;
  top: 7px;
  left: 7px;
}

.chat-widget {
  position: fixed;
  bottom: 0px;
  right: 20px;
  z-index: 1000;
  background: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
  border-radius: 3px 3px 0px 0px;
  -moz-border-radius: 3px 3px 0px 0px;
  -webkit-border-radius: 3px 3px 0px 0px;
  height: 617px;
  display: flex;
  flex-direction: column;
}

.chat-widget2 {
  position: fixed;
  bottom: 0px;
  right: 20px;

  z-index: 1000;

  background: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
  border-radius: 3px 3px 0px 0px;
  -moz-border-radius: 3px 3px 0px 0px;
  -webkit-border-radius: 3px 3px 0px 0px;

  height: 617px;
  width: 450px;

  display: flex;
  flex-direction: column;
}

.chat-widget1 {
  position: fixed;
  bottom: 10px;
  right: 20px;
  z-index: 1000;
  background: #fff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
  border-radius: 3px 3px 0px 0px;
  -moz-border-radius: 3px 3px 0px 0px;
  -webkit-border-radius: 3px 3px 0px 0px;
  display: flex;
  flex-direction: column;
  max-width: 345px !important;
  border-radius: 0 0 20px 20px;
}

.error {
  font-size: 0.9em;
  color: #721c24;
  font-weight: bold;
}

.chat-widget-header {
  background: #f6f7f9;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  /* flex: 0 0; */
  padding: 0px 7px;
  font-weight: bold;
  color: #4b4f56;
  font-size: 12px;
  /* line-height: 26px; */
  width: 100.2% !important;
  height: 40px !important;
}

.chat-widget-online-status {
  background-color: #77d077;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  border: 1px #54b554 solid;
  display: inline-block;
}

.chat-widget-offline-status {
  background-color: #dc3545;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  border: 1px #dc3545 solid;
  display: inline-block;
}

.chat-widget-header>div {
  display: flex;
  flex-direction: row;
  width: 100%;
  /* height: 60px !important; */
}

.chat-widget-header .left {
  flex: 1 0;
}

.chat-widget-header .right {
  flex: 0 0;
  font-size: 3em !important;
  align-items: baseline;
  line-height: 20px;
}

.chat-widget-header .right a {
  color: #777c86;
}

.chat-widget-header .right a:hover {
  color: #989da5;
}

.chat-widget-messages {
  background: #fff;
  flex: 1 0;
  overflow-y: scroll;
  padding: 0;
}

.chat-widget-messages ul {
  list-style-type: none;
  margin: 6px 10px 0 10px;
  padding: 0;
}

.chat-widget-messages li {
  margin-bottom: 5px;
}

.chat-widget-messages li.mine {
  text-align: right;
}

.chat-widget-messages li div {
  border-radius: 7px;
  padding: 3px 6px;
  display: inline-block;
}

.chat-widget-messages li.mine div {
  background: #0A92C4;
  color: white;
}

.chat-widget-messages li.pending div {
  background: #a2bbd0;
}

.chat-widget-messages li.error div {
  background: #b30505;
}

.invalid {
  border-color: #b30505 !important;
}

.chat-widget-messages li.remote div {
  background: #d2d4d9;
  color: black;
}

.chat-widget-input {
  border-top: 1px #e6e6e6 solid;
  flex: 0 0;
  height: 80px;
}

#envia {
  margin-top: 55%;
  font-size: 1.7em;
}

.chat-widget-input textarea {
  width: 100%;
  height: 100%;
  border: 1;
  padding: 4px;
  border-radius: 10px;

  margin: 4px;
}

/*---------chat window---------------*/
.container {
  max-width: 900px;
}

.inbox_people {
  background: #fff;
  float: left;
  overflow: hidden;
  width: 30%;
  border-right: 1px solid #ddd;
}

.inbox_msg {
  border: 1px solid #ddd;
  clear: both;
  overflow: hidden;
}

.top_spac {
  margin: 20px 0 0;
}

.recent_heading {
  float: left;
  width: 40%;
}

.srch_bar {
  display: inline-block;
  text-align: right;
  width: 60%;
  padding: ;
}

.headind_srch {
  padding: 10px 29px 10px 20px;
  overflow: hidden;
  border-bottom: 1px solid #c4c4c4;
}

.recent_heading h4 {
  color: #0A92C4;
  font-size: 16px;
  margin: auto;
  line-height: 29px;
}

.srch_bar input {
  outline: none;
  border: 1px solid #cdcdcd;
  border-width: 0 0 1px 0;
  width: 80%;
  padding: 2px 0 4px 6px;
  background: none;
}

.srch_bar .input-group-addon button {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  padding: 0;
  color: #707070;
  font-size: 18px;
}

.srch_bar .input-group-addon {
  margin: 0 0 0 -27px;
}

.chat_ib h5 {
  font-size: 15px;
  color: #464646;
  margin: 0 0 8px 0;
}

.chat_ib h5 span {
  font-size: 13px;
  float: right;
}

.chat_ib p {
  font-size: 12px;
  color: #989898;
  margin: auto;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat_img {
  float: left;
  width: 11%;
}

.chat_img img {
  width: 100%;
}

.chat_ib {
  float: left;
  padding: 0 0 0 15px;
  width: 88%;
}

.chat_people {
  overflow: hidden;
  clear: both;
}

.chat_list {
  border-bottom: 1px solid #ddd;
  margin: 0;
  padding: 18px 16px 10px;
}

.inbox_chat {
  height: 550px;
  overflow-y: scroll;
}

.active_chat {
  background: #e8f6ff;
}

.incoming_msg_img {
  display: inline-block;
  /* width: 6%; */
}

.incoming_msg_img img {
  width: 100%;
}

.received_msg {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
}

.received_msg_user {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 92%;
}

.received_msg_user {
  display: inline-block;
  padding: 0 0 0 10px;
  vertical-align: top;
  width: 46%;
}

.received_withd_msg p {
  background: #ebebeb none repeat scroll 0 0;
  border-radius: 0 15px 15px 15px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 100%;
  font-family: Montserrat, sans-serif;
}

.received_withd_msg pre {
  background: #ebebeb none repeat scroll 0 0;
  border-radius: 0 15px 15px 15px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 100%;
  font-family: Montserrat, sans-serif;
}


.received_withd_msg_user p {
  background: #ebebeb none repeat scroll 0 0;
  border-radius: 0 15px 15px 15px;
  color: #646464;
  font-size: 14px;
  margin: 0;
  padding: 5px 10px 5px 12px;
  width: 100%;
  font-family: Montserrat, sans-serif;
}

.time_date {
  color: #747474;
  display: block;
  font-size: 12px;
  margin: 8px 0 0;
}

.received_withd_msg {
  width: fit-content;
  font-family: Montserrat, sans-serif;
}

.mesgs {
  padding: 0px 15px 0 25px;
  width: 100%;
}

.sent_msg p {
  background: #0A92C4;
  border-radius: 12px 0px 15px 15px;
  font-size: 14px;
  margin: 0;
  color: #fff;
  padding: 5px 10px 5px 12px;
  width: 100%;
}

.outgoing_msg {
  overflow: hidden;
  margin: 26px 0 26px;
}

.sent_msg {
  float: right;
  width: 46%;
}

.input_msg_write input {
  background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
  border: medium none;
  color: #4c4c4c;
  font-size: 15px;
  min-height: 48px;
  width: 100%;
  outline: none;
}

.type_msg {
  border-top: 1px solid #c4c4c4;
  position: relative;
}

.msg_send_btn {
  /* background: #0165a1 none repeat scroll 0 0; */
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 15px;
  height: 33px;
  width: 33px;
}

.msg_attach_btn {
  /* background: #0165a1 none repeat scroll 0 0; */
  background: transparent;
  border: none;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  font-size: 15px;
  height: 33px;
  position: absolute;
  right: 0;
  top: 11px;
  right: 35px;
  width: 33px;
}

.messaging {
  position: relative;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
  background: #fff;
  border-radius: 0 0 20px 20px;
  max-height: 100%;
}

.msg_history {
  position: relative;
  overflow-y: scroll;
  padding-top: 10px;
}
</style>
